import React from 'react';
import { translate } from '../Services/translation';

const FacetedSearchCompact = ({
  facetFilters,
  visibleDropdownMenu,
  toggleVisibleDropdownMenu,
  onFacetChange,
  onSubmit,
}) => (
  <ul className="faceted-search faceted-search--compact flex flex-wrap gap-4">
    {facetFilters &&
      facetFilters.map(
        (group, groupIndex, array) =>
          group.options &&
          group.options.length > 0 && (
            <li
              className="columns small-6 large-3 faceted-search__group"
              key={`${group.label}-${groupIndex}`}
            >
              <div className="faceted-search__group--inner relative">
                <button
                  type='button'
                  aria-expanded={visibleDropdownMenu.includes(group.id)}
                  aria-controls={`faceted-search__sublist-${group.id}`}
                  className='faceted-search__group-header border border-border-secondary rounded-radius px-4 py-2 text-text-tertiary aria-expanded:bg-grey-darker aria-expanded:text-white peer'
                  onClick={(event) => toggleVisibleDropdownMenu(group)}
                >
                  {group.label}
                </button>
                <ul 
                  id={`faceted-search__sublist-${group.id}`}
                  className="faceted-search__sublist absolute left-0 right-0 z-10 w-max invisible peer-aria-expanded:visible p-4 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.25)] before:absolute before:content-[''] before:border-8 before:border-transparent before:border-b-white before:border-b-[10px] before:-top-4 before:left-4 before:z-10"
                  >
                  {group.options &&
                    group.options.map((item, itemIndex, array) => (
                      <li
                        key={`${item.label}-${itemIndex}`}
                        className="faceted-search__item py-2"
                      >
                        <FacetedFilterCheckbox
                          item={item}
                          group={group}
                          onFacetChange={onFacetChange}
                        />
                      </li>
                    ))}
                  <li className="faceted-search__item py-2">
                    <button
                      className="filter__button button text-sm font-medium min-w-[120px]"
                      onClick={(event) => {
                        toggleVisibleDropdownMenu(group);
                        onSubmit(facetFilters);
                      }}
                    >
                      {translate('general.select')}
                    </button>
                  </li>
                </ul>
              </div>
            </li>
          )
      )}
  </ul>
);

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
  <label className="faceted-filter flex items-center gap-2 cursor-pointer">
    <input
      className="faceted-filter__input"
      type="checkbox"
      onChange={(event) => onFacetChange(group, item)}
      checked={group.selectedOptions.includes(item.id)}
    />
    <span className="faceted-filter__label">
      {item.label}
      {!isNaN(item.quantity) && item.quantity > 0 && (
        <span className="faceted-filter__quantity"> ({item.quantity})</span>
      )}
    </span>
  </label>
);

export default FacetedSearchCompact;
